module.exports = __webpack_public_path__ + "static/media/turkey.ff5b1209.svg";